import { Button, Modal, Form, Row, Col, Input, Select, message } from "antd";
import { useEffect, useState } from "react";
import createVehicle from "../../../../services/createVehicle";
import fetchAllContacts from "../../../../services/fetchAllContacts";

const { Option } = Select;
const { TextArea } = Input;
type RequiredMark = boolean | "optional";

export default function CreateVehicle({ isVisible, hideModal, refetch }: any) {
  const [contacts, setContacts] = useState<any>([]);
  const [isLoading, setLoading] = useState(false);
  const [requiredMark, setRequiredMarkType] =
    useState<RequiredMark>("optional");

  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const values = await form.validateFields();
    const data = {
      _id: values.registration,
      isDeleted: false,
      magic: 0,
      ...values,
    };
    const response = await createVehicle(data);
    setLoading(false);
    hideModal();
    if (response.success) {
      refetch();
      message.success("Vehicle added successfully");
    } else {
      message.error(response.message);
    }
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const handleFetchContacts = async () => {
    const data = await fetchAllContacts();
    setContacts(data?.payload);
  };

  useEffect(() => {
    handleFetchContacts();
  }, []);

  const onRequiredTypeChange = ({
    requiredMarkValue,
  }: {
    requiredMarkValue: RequiredMark;
  }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  const contactOptions = contacts?.map((contact: any, index: number) => {
    return (
      <Option value={contact._id} key={index}>
        {contact?.customer?.name}
      </Option>
    );
  });

  return (
    <Modal
      visible={isVisible}
      title="New Vehicle"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createVehicle"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createVehicle"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
        initialValues={{ requiredMarkValue: requiredMark }}
        requiredMark={requiredMark}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="registration"
              label="Registration"
              rules={[
                {
                  required: true,
                  message: "Please enter registration",
                },
              ]}
            >
              <Input placeholder="Registration" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="chassis"
              label="Chassis"
              rules={[
                {
                  required: true,
                  message: "Please enter chassis number",
                },
              ]}
            >
              <Input placeholder="Chassis" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="make"
              label="Make"
              rules={[
                {
                  required: true,
                  message: "Please enter make",
                },
              ]}
            >
              <Input placeholder="Make" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="model"
              label="Model"
              rules={[
                {
                  required: true,
                  message: "Please enter model",
                },
              ]}
            >
              <Input placeholder="Model" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="year"
              label="Year"
              rules={[
                {
                  required: true,
                  message: "Please enter year",
                },
              ]}
            >
              <Input placeholder="Year" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mileage"
              label="Mileage"
              rules={[
                {
                  required: true,
                  message: "Please enter mileage",
                },
              ]}
            >
              <Input placeholder="Mileage" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="contact"
              label="Contact"
              rules={[
                {
                  required: true,
                  message: "Please select contact",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {contactOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: false,
                  message: "Please enter description",
                },
              ]}
            >
              <TextArea placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
